var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegisterSignin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1234 -4957)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 63,
    rx: 12,
    transform: "translate(1234 4957)",
    fill: "#3488eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.817,3H25.452A3.409,3.409,0,0,1,28.86,6.409v23.86a3.409,3.409,0,0,1-3.409,3.409H11.817M22.043,18.339l-6.817-6.817m6.817,6.817-6.817,6.817m6.817-6.817H5",
    transform: "translate(1251.5 4970.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterSignin);
export default __webpack_public_path__ + "static/media/register-signin.0dcb3fb6e3900349e0b71f9abedb22fc.svg";
export { ForwardRef as ReactComponent };